import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PopupLoginComponent } from 'src/app/components/modals/popup-login/popup-login.component';
import { PopupRealTimeBiddingComponent } from 'src/app/components/modals/popup-real-time-bidding/popup-real-time-bidding.component';
import { IAnimal } from 'src/app/models/animal';
import { IAuctionBid, IOpenedSchedule } from 'src/app/models/transactions';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-pre-bid-action',
  templateUrl: './pre-bid-action.component.html',
  styleUrls: ['./pre-bid-action.component.scss'],
})
export class PreBidActionComponent implements OnInit{
  constructor(private storage: StorageService, private dialog: MatDialog) {}

  @Input() animal_obj: IAnimal = {} as IAnimal;
  @Input() auction_bid: IAuctionBid = {} as IAuctionBid;
  @Input() opened_schedule: IOpenedSchedule = {} as IOpenedSchedule;

  @Input() is_live: 'LIVE' | 'DETAILS' = 'LIVE';

  @Input() list_bids: any = [];
  @Input() increment = 0;
  @Input() attual_bid = 0;
  @Input() next_bid = 0;
  @Input() isStatus: 'ACEITO' | 'SUPERADO' | 'RECUSADO' |  'AGUARDANDO'  | '' = '';
  @Output() eventSocket = new EventEmitter<any>();

  analizing_bid = false;
  winning = false;

  loading = true;
  user = this.storage.myself;

  // constructor() { }
  ngOnInit(): void {
    console.log('---------PRELANCE---------');

    console.log(this.next_bid);
    console.log(this.attual_bid);


    // this.analizing_bid = this.isStatus === 'AGUARDANDO'
    this.winning = this.isStatus === 'ACEITO'
  }


  openPopupPreBid() {
    if (!this.storage.token || this.storage.token === '') {
      this.openPopuplogIn();
      return;
    }

    const dialogRef = this.dialog.open(PopupRealTimeBiddingComponent, {
      width: '90%',
      maxWidth: '500px',
      disableClose: true,
      data: {
        id: this.auction_bid.id,
        animal: this.animal_obj,
        increment: this.increment,
        auction_bid: this.auction_bid,
        attual_bid: Number(this.attual_bid || 0) + Number(this.increment || 0) || 0,
        next_bid: this.next_bid,
        max_bid: this.attual_bid * (this.attual_bid < 100 ? 3.5 : 1.5),
        enableBid: true,
        timer: null,
        type: 'PRELANCE',
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result.action === 'yes') {
        this.eventSocket.emit(true);
      }
    });
  }

  openPopuplogIn() {
    const popupLoginRef = this.dialog.open(PopupLoginComponent, {
      width: '90%',
      maxWidth: '400px',
    });
    popupLoginRef.afterClosed().subscribe((result: any) => {
      if (result.action === 'yes') {
        this.eventSocket.emit(false);
      }
    });
  }
}
